export default "__VITE_ASSET__CIw8pWsd__"